import personTranslations from "./personTranslations";
import litigationCaseTranslations from "./litigationCaseTranslations";
import { prosecutionTranslations } from "./prosecutionTranslations";
import opposingPartyLegalEntityTranslations from "./opposingPartyLegalEntityTranslations";
import organizationEmailTranslations from "./organizationEmailTranslations";

const contractClaimTranslations = {
  ...litigationCaseTranslations,
  personalTextMessage: {
    label: "Kurzbeschreibung Mandantschaft",
  },
  additionalClaimText: {
    label: "Zusatztext Forderung",
  },
  additionalIssueDescriptionText: {
    label: "Zusatztext Schilderung Sachverhalt",
  },
  buyerPaidAmount: {
    label: "Gezahlter Betrag Käufer",
  },
  buyerPaidDate: {
    label: "Zahlungsdatum Käufer",
  },
  buyerPaidStatus: {
    label: "Bezahlstatus Käufer",
    values: {
      fully: "vollständig",
      partially: "teilweise",
      none: "noch gar nicht",
    },
  },
  responsibleProsecution: prosecutionTranslations,
  contractNumber: {
    label: "Vertragsnummer",
  },
  contractDate: {
    label: "Vertragsabschluss am",
  },
  contractualPartnerPerson: personTranslations,
  contractualPartnerLegalEntity: {
    organizationEmail: organizationEmailTranslations,
    organization: {
      label: "Gegenseite",
      ...opposingPartyLegalEntityTranslations,
    },
  },
  goodsOrServiceProvidedStatus: {
    label: "Status Leistungserbringung/Lieferung",
    values: {
      fully: "vollständig",
      partially: "teilweise",
      none: "noch gar nicht",
    },
  },
  goodsOrServiceProvidedDate: {
    label: "Datum der Leistung/Lieferung",
  },
  overdueFees: {
    label: "Mahngebühren",
  },
  subjectOfDispute: {
    label: "Forderung",
    values: {
      money: "Geld",
      goods: "Ware oder Leistung",
      other: "Sonstiges",
    },
    enforceClaim: {
      label: "Forderung Mandantschaft",
      values: {
        money: "Geld",
        goods: "Ware oder Leistung",
        other: "Sonstiges",
      },
    },
    defendClaim: {
      label: "Forderung Gegenseite",
      values: {
        money: "Geld",
        goods: "Ware oder Leistung",
        other: "Sonstiges",
      },
    },
  },
  advisoryAppointment: {
    label: "Beratungsgespräch",
  },
};

export default contractClaimTranslations;
